const React = require('react');
const TextField = require('@material-ui/core/TextField').default;


module.exports = ({
  className,
  helperText,
  ...props
}) => {
  return (
    <div className={className || ''}>
      <TextField
        margin="none"
        variant="outlined"
        {...props}
        className="w
          (ph25|pv9|hmin45|bgF|bxzBB)>.MuiOutlinedInput-input
          (f14|fw3|lts0.05em|c0)>.MuiOutlinedInput-root
          (dn|b1-i|r9)>.*-notchedOutline*2
          bc8>:not[.Mui-error]>.*-notchedOutline*2
          bc0>(.Mui-focused|:h):not[.Mui-disabled]:not[.Mui-error]>.*-notchedOutline*2
          bgF>.*focused.*Input-root
          (x20y16s100|f12|ph5|bgF|fw3|ff$3)>.MuiFormLabel-root*2
          c0>.MuiFormLabel-root:not[.Mui-error]*2
          x20y-6s100>.MuiFormLabel-root.MuiInputLabel-shrink*2
          dN>legend
          st0>.*-notchedOutline
          (ov|r9)>.MuiInputBase-root
          c0.5>.MuiFormLabel-root.Mui-disabled*2
          o50>.MuiInputBase-root.Mui-disabled
         "
      />
      {
        props.error ? (<div className="rlv">
          <div
            className="abs sh25 st f11 cF00 fw4"
          >{helperText || 'Obligatory field'}</div>
        </div>) : null
      }
    </div>
  );
};
